import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'SetEntryFlashGameFlag',
            args: {
                promotion: payload.promotion ? payload.promotion : config.promotion,
                flag: payload.flag ? payload.flag : 2,
                game_id: payload.game_id ? payload.game_id : config.promotion_id,
                entry_id: payload.entry_id,
            },
        });
        return result;
    };
};
